<template>
    <div id="app">
      <router-view />
    </div>

</template>

<script>
import api from '@/api/api'
import { sendConvertData } from '@/utils/baidu'
export default {
  name: 'App',
  created() {
    //记录百度推广链接
    let logidUrl = window.location.href
    if (logidUrl.indexOf('bd_vid') != -1) {
      const local_bd = localStorage.getItem('logidUrl')
      localStorage.setItem('logidUrl', logidUrl)
      if (logidUrl !== local_bd) {
        const conversionTypes = {
          logidUrl: localStorage.getItem('logidUrl'),
          newType: 4,
          deviceType: 2
        }
        sendConvertData(conversionTypes).then(res => {
          console.log('调用转化成功=', res)
        }).catch((err) => {
          console.log('调用转化失败=', err)
        })
      }
    }
    console.log('刷新会进入这个app.vue页面')
    api.getUserinfo().then(res1 => {
      if (res1.code === 200) {
        if (!res1.data.signIn) {
          // sendConvertData({})
          api.setUserLoginState({ id: res1.data.id })
        }
      }
    })
  },
}
</script>
